/**
* @copyright
* Copyright(c) 2018 SICK AG
*/

const style = `
:host {
  box-sizing: border-box;
  font-size: 1rem;
  display: block;
}

.link-wrapper {
  display: flex;
  position: relative;
  width: inherit;
  align-items: center;
}
.link-wrapper:hover {
  background-color: #009DF4;
  background-color: var(--davinci-color-primary-light, #009DF4);
  cursor: pointer;
}

:host .link-wrapper.nested {
  padding: 0.2857142857rem 0;
}
:host .link-wrapper.level-1 {
  padding: 0.5714285714rem 0;
  padding-left: 1.1428571429rem;
}
:host .link-wrapper.level-2 {
  padding-left: 2.2857142857rem;
}
:host .link-wrapper.level-3 {
  padding-left: 3.4285714286rem;
}
:host .link-wrapper.level-4 {
  padding-left: 4.5714285714rem;
}
:host .link-wrapper.level-5 {
  padding-left: 5.7142857143rem;
}
:host .link-wrapper.level-6 {
  padding-left: 6.8571428571rem;
}

:host(.drawer-expanded) .link-wrapper.level-1 {
  padding-left: 3.4285714286rem;
}
:host(.drawer-expanded) .link-wrapper.level-2 {
  padding-left: 4.5714285714rem;
}
:host(.drawer-expanded) .link-wrapper.level-3 {
  padding-left: 5.7142857143rem;
}
:host(.drawer-expanded) .link-wrapper.level-4 {
  padding-left: 6.8571428571rem;
}
:host(.drawer-expanded) .link-wrapper.level-5 {
  padding-left: 8rem;
}
:host(.drawer-expanded) .link-wrapper.level-6 {
  padding-left: 9.1428571429rem;
}

.toggle {
  min-width: 1.7142857143rem;
  min-height: 1.7142857143rem;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
  margin-right: 0.8571428571rem;
}

.link {
  display: flex;
  align-items: center;
  flex-grow: 1;
  line-height: 1.7142857143rem;
}
.link .icon-box {
  margin: 0.8571428571rem;
  line-height: normal;
  align-self: flex-start;
}
.link .icon {
  min-width: 1.7142857143rem;
  min-height: 1.7142857143rem;
  width: 1.7142857143rem;
  height: 1.7142857143rem;
  fill: #FFFFFF;
  fill: var(--davinci-color-light, #FFFFFF);
}
.link .text {
  margin-right: 1.1428571429rem;
}

.children {
  display: none;
}
.children.expanded {
  display: block;
}

:host(.flyout) {
  position: relative;
}
:host(.flyout) .header {
  padding: 0.8571428571rem 0.8571428571rem 0.8571428571rem 1.1428571429rem;
  font-weight: 700;
  line-height: 1.4285714286rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
:host(.flyout) .header .text {
  display: flex;
  align-self: center;
}
:host(.flyout) .children {
  position: fixed;
  display: block;
  top: -100000px;
  left: -100000px;
}
:host(.flyout) .children.expanded {
  z-index: 20;
}
:host(.flyout) .flyout-wrapper {
  margin: 0.2857142857rem 0 0 0;
  width: 18.2857142857rem;
  overflow: visible;
  position: relative;
  left: 1.2857142857rem;
  background-color: #737F85;
  background-color: var(--davinci-color-secondary, #737F85);
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.2), 0px 20px 31px 3px rgba(0, 0, 0, 0.14), 0px 8px 38px 7px rgba(0, 0, 0, 0.12);
  padding-bottom: 0.2857142857rem;
}
:host(.flyout) .flyout-wrapper:after {
  right: 100%;
  top: 1.7142857143rem;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-right-color: #737F85;
  border-right-color: var(--davinci-color-secondary, #737F85);
  border-width: 0.5714285714rem;
  margin-top: -0.8571428571rem;
}
:host(.flyout) .children.upwards .flyout-wrapper::after {
  top: initial;
  bottom: 1.1428571429rem;
}

:host(.root) .link .text {
  font-weight: 700;
}

:host([disabled]) .link-wrapper {
  color: #C5CACC;
  color: var(--davinci-color-mid-gray-3, #C5CACC);
}
:host([disabled]) .link-wrapper:hover {
  background-color: transparent;
  cursor: default;
}
:host([disabled]) .link-wrapper .header {
  color: #C5CACC;
  color: var(--davinci-color-mid-gray-3, #C5CACC);
}
:host([disabled]) .link-wrapper .toggle,
:host([disabled]) .link-wrapper .link .icon {
  fill: #C5CACC;
  fill: var(--davinci-color-mid-gray-3, #C5CACC);
}

:host([active]:not([disabled])) .link-wrapper {
  color: #FFFFFF;
  color: var(--davinci-color-text-on-secondary-dark, #FFFFFF);
  background-color: #50585C;
  background-color: var(--davinci-color-secondary-dark, #50585C);
}
`;
export { style };
